<template>
  <div
    v-if="is_full_page"
    class="bg-opacity-50 fixed inset-0 flex items-center justify-center bg-black"
  >
    <ProgressSpinner class="h-12 w-12" />
  </div>
  <div
    v-else
    class="relative flex items-center justify-center"
    :style="{ height }"
  >
    <ProgressSpinner class="h-12 w-12" />
  </div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';

defineProps({
  is_full_page: { type: Boolean },
  height: { type: String, default: '100px' },
});
</script>
